import ReactDOM from "react-dom";
import React, { useState } from "react";
import * as $ from "jquery";
import * as _ from "lodash";

import { QuickFilterUtils } from "../extensions/filter/quickFilterUtils";
import { UiUtils } from "../common/uiUtils";
import { SettingsUtils } from "../extensions/settings/settingsUtils";
import * as SmartDrawings from "../smartDrawings";
import { viewerState } from "../viewer";
import { ViewerUtils } from "../common/viewerUtils";

const search = (term, exact, viewer) => {
    const url = new URL(location.href);

    if (!_.isEmpty(term)) {
        if (term.length < 3) {
            UiUtils.notifyError("The search term needs to have at least three characters.");
            return;
        }

        let op = "~";
        if (exact) {
            op = "=";
        }

        const zoom = SettingsUtils.loadSingleSetting("searchZoom");
        QuickFilterUtils.selectWithFilterString(`*,*,${op},${term}`, viewer, zoom);

        url.searchParams.set(SmartDrawings.SdUrlParameters.SEARCH, term);
        if (exact) {
            url.searchParams.set(SmartDrawings.SdUrlParameters.EXACT_MATCH, exact);
        } else {
            url.searchParams.delete(SmartDrawings.SdUrlParameters.EXACT_MATCH);
        }
    } else {
        url.searchParams.delete(SmartDrawings.SdUrlParameters.SEARCH);
        url.searchParams.delete(SmartDrawings.SdUrlParameters.EXACT_MATCH);
    }

    (window as Window).history.replaceState(null, "", url.href);
}

let searchBarLoaded = false;
let updateStateWithoutRender = (updateTerm, updateExact) => {}

const SearchBar = (props) => {
    const [term, setTerm] = useState("");
    const [exact, setExact] = useState(false);
    const [show, setShow] = useState(false);

    const onRoleChange = event => {
        setShow(viewerState.currentRole.universalSearch ?? true);
        updateSearchBar(props.viewer);
    }

    React.useEffect(() => {
        searchBarLoaded = true;

        props.viewer.addEventListener(SmartDrawings.SdEvents.SD_ROLE_CHANGE, onRoleChange);

        // cleanup this component
        return () => {
            props.viewer.removeEventListener(SmartDrawings.SdEvents.SD_ROLE_CHANGE, onRoleChange);
        };

    }, []);

    updateStateWithoutRender = (updateTerm, updateExact) => {
        setTerm(updateTerm);
        setExact(updateExact);
    }

    return show ? <form onSubmit={(e) => {
        e.preventDefault();
        search(term, exact, props.viewer);
    }}>
        <div className="input-group ml-1">
            <div className="input-group-prepend">
                <span className="input-group-text bg-primary border-0" data-toggle="tooltip" title="Exact match">
                    <input id="exactCheck" type="checkbox" checked={exact} onChange={() => setExact(!exact)} />
                </span>
            </div>
            <input id="searchText" type="text" className="form-control-sm" placeholder="Search" value={term} onChange={event => setTerm(event.target.value)} />
            <div className="input-group-append">
                <button className="btn btn-sm btn-primary" type="submit"><span className="icon ion-md-search pr-0" /></button>
            </div>
            
        </div>
    </form> : null;
}

const initSearch = (viewer) => {
    const bar = document.getElementById("search-bar");
    if (bar != null) {
        ReactDOM.render(<SearchBar viewer={viewer}/>, bar);
    }
}

const updateSearchBar = (viewer) => {
    if (ViewerUtils.hasUrlParam(SmartDrawings.SdUrlParameters.SEARCH)) {
        const url = new URL(location.href);

        let term = ViewerUtils.getUrlParamValue(SmartDrawings.SdUrlParameters.SEARCH);
        let exact = ViewerUtils.isUrlParamValueTrue(SmartDrawings.SdUrlParameters.EXACT_MATCH);

        $("#searchText").prop("value", term);
        $("#exactCheck").prop("checked", exact);

        updateStateWithoutRender(term, exact);
    }
}

const checkSearchReady = async () => {
    while (await new Promise(resolve => setTimeout(() => resolve(!searchBarLoaded), 10))) { }
}

export {
    initSearch,
    search,
    updateSearchBar,
    checkSearchReady
};